import { Div } from "@tblabs/truffle";
import { ProductCategoryBox } from "./ProductCategoryBox";
import { SearchBox } from "./SearchBox";
import { ShopContentProvider } from "../../Services/Content/ShopContentProvider";


export class CategoriesBox extends Div
{
    constructor(_shop: ShopContentProvider)
    {
        super("container");
        this.Id("kategorie-produktow");

        let categories = _shop.Shop.ProductCategories.Items;
        if (!_shop.IsAuthorized)
        {
            categories = categories.filter(x => x.Visible.value);
        }

        const availableProducts = _shop.Shop.AvailableProducts;

        this.Append(
            new SearchBox(availableProducts),
            new Div("products").Id("products").Append(
                ...categories.map(x =>
                    new ProductCategoryBox(x, _shop)
                        .Style(x.Visible.IsTrue() ? "" : "opacity: 0.5;")
                )
            )
        );
    }
}
